import React from "react";
import { Progress, Tooltip, theme } from "antd";
import { useTranslation } from "react-i18next";
import { BAND_COLORS } from "./constants";

// The score never appears without how much it is based on: a bare notice scores high on the few
// facts it has, and that must not read like a certain match.
const ScoreBadge = ({ fit, size = 52 }) => {
  const { t } = useTranslation("dashboard");
  const { token } = theme.useToken();
  const confidence = {
    HIGH: t("Based on most of the relevant facts"),
    MEDIUM: t("Based on part of the relevant facts"),
    LOW: t("Based on few facts — first indication only")
  }[fit.confidence];
  return (
    <Tooltip title={`${t("Fit")}: ${fit.score}/100 · ${confidence}`}>
      <div style={{ opacity: fit.confidence === "LOW" ? 0.75 : 1, textAlign: "center" }}>
        <Progress
          type="circle"
          size={size}
          percent={fit.score}
          strokeColor={BAND_COLORS[fit.band]}
          format={p => <span style={{ fontSize: size / 3.4, fontWeight: 600 }}>{p}</span>}
          strokeLinecap="butt"
          {...(fit.confidence === "LOW" ? { strokeWidth: 5 } : {})}
        />
        {fit.confidence === "LOW" && (
          <div style={{ fontSize: 10, color: token.colorTextSecondary, marginTop: 2 }}>
            {t("few facts")}
          </div>
        )}
      </div>
    </Tooltip>
  );
};

export default ScoreBadge;
